import ResourcesModal from './ResourcesModal';

export default ResourcesModal;
